import { memo, useCallback, useMemo, useState, useTransition } from "react";

import { CircleLoading } from "@/components/ui/loading/circle";

import { PlanStockTableForMobile } from "./components";
import { StockManagementScrollToTodaysStockItemMobile, YearAndMonthSelectBox } from "../../../../_shared";
import { FilterInSaleAndStopSellingForMobile } from "../../../../_shared/components/filter/filter-insale-and-stop-selling/components";
import { useCreateInSaleAndStopSellingFilterProps } from "../hooks";

import type { PlanStockDiffStore } from "../../../model/usecase/use-create-form-model/plan-stock-diff-store";
import type { ServerModel } from "../../../model/usecase/use-create-form-model/type";

type Props = {
	todaysDt: string;
	startDt: string;

	handleOnSelectYearOrMonth: (input: { startDt: string; endDt: string }) => Promise<void>;

	serverModel: ServerModel;
	planStockDiffStore: PlanStockDiffStore;
};

export const PlanStockManagementForMobile = memo(
	({ todaysDt, startDt, serverModel, handleOnSelectYearOrMonth, planStockDiffStore }: Props) => {
		const { stopSellingItems, inSaleItems, itemsName } = useCreateInSaleAndStopSellingFilterProps({ serverModel });

		const initialSelectedItemIDs: string[] = useMemo(() => {
			return inSaleItems.length ? [inSaleItems[0].id] : [stopSellingItems[0].id];
		}, [inSaleItems, stopSellingItems]);

		const [isPending, startTransition] = useTransition();
		const [selectedItemIDs, setSelectedItemIDs] = useState<string[]>(initialSelectedItemIDs);
		const onChangeSelectedItemIDs = useCallback((input: string[]) => {
			startTransition(() => {
				setSelectedItemIDs(input);
			});
		}, []);

		return (
			<>
				<div className="flex flex-col gap-y-6">
					<YearAndMonthSelectBox
						initialDt={todaysDt}
						onSelectYearOrMonthCallback={handleOnSelectYearOrMonth}
					/>
					<FilterInSaleAndStopSellingForMobile
						isPending={isPending}
						itemsName={itemsName}
						selectedItemIDs={selectedItemIDs}
						onChangeSelectedItemIDs={onChangeSelectedItemIDs}
						inSaleItems={inSaleItems}
						stopSellingItems={stopSellingItems}
					/>
					<StockManagementScrollToTodaysStockItemMobile selectedDate={startDt} />
				</div>

				{isPending ? (
					<CircleLoading size="sm" />
				) : (
					<PlanStockTableForMobile
						serverModel={serverModel}
						planStockDiffStore={planStockDiffStore}
						selectedItemIDs={selectedItemIDs}
					/>
				)}
			</>
		);
	},
);

PlanStockManagementForMobile.displayName = "PlanStockManagementForMobile";
